var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5L6.793 1.293C6.60551 1.10545 6.35119 1.00006 6.086 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V10C1 10.2652 1.10536 10.5196 1.29289 10.7071C1.48043 10.8946 1.73478 11 2 11H8C8.26522 11 8.51957 10.8946 8.70711 10.7071C8.89464 10.5196 9 10.2652 9 10M3 9H3.5M9.689 6.313C9.88818 6.11382 10.0001 5.84368 10.0001 5.562C10.0001 5.28032 9.88818 5.01018 9.689 4.811C9.48982 4.61182 9.21968 4.49993 8.938 4.49993C8.65632 4.49993 8.38618 4.61182 8.187 4.811L6.182 6.817C6.06312 6.93581 5.97611 7.08267 5.929 7.244L5.5105 8.679C5.49795 8.72202 5.4972 8.76763 5.50832 8.81105C5.51944 8.85446 5.54203 8.89409 5.57372 8.92578C5.60541 8.95747 5.64504 8.98006 5.68845 8.99118C5.73187 9.0023 5.77748 9.00155 5.8205 8.989L7.2555 8.5705C7.41683 8.52339 7.56369 8.43638 7.6825 8.3175L9.689 6.313Z",
    stroke: "#7F7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeEdit);
export default __webpack_public_path__ + "res/media/node_edit.2f9ec73121f091689285083fdaa5c48c.svg";
export { ForwardRef as ReactComponent };